import React from 'react'
import { ArrowRight } from "lucide-react"
import dental from '../../assets/dental/dental.png'
import { FiArrowUpRight } from "react-icons/fi";
import girl from '../../assets/dental/girl.png'
import img1 from '../../assets/dental/img1.jpg'
import img2 from '../../assets/dental/img2.jpg'
import img3 from '../../assets/dental/img3.jpg'
import img4 from '../../assets/dental/img4.jpg'
import dent1 from '../../assets/dental/dent1.jpg'
import dent2 from '../../assets/dental/dent2.jpg'
import form from '../../assets/dental/form.png'
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCreateDentalContactMutation } from '../../store/api/contact'
import Loader from "../../components/common/Loader";
import Dentalanimations from '../../../src/assets/animations/Dental clinic.json'
function Dental() {
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate()
  const [openCard, setOpenCard] = useState(null);
  const handleToggle = (cardName) => {
    setOpenCard(openCard === cardName ? null : cardName);
  };
  const [createDentalContact, { isLoading, isError, isSuccess, error }] = useCreateDentalContactMutation();
  useEffect(() => {
  // Simulate loading completion
  const timer = setTimeout(() => setLoading(false), 3000);
  return () => clearTimeout(timer);
}, []);
  useEffect(() => {
    if (isSuccess) {
      setShowSuccess(true);
      const timer = setTimeout(() => setShowSuccess(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess]);
    const [loading, setLoading] = useState(true);
  const [connectOpen, setConnectOpen] = useState(false);
  const [timingsOpen, setTimingsOpen] = useState(false)

  const services = [
    {
      number: "1",
      title: "Preventive Care",
      description: "X-rays, Cleaning, Fissure Sealants",
      bgColor: "bg-[#F2F2F2]",
    },
    {
      number: "2",
      title: "Restorative Treatments",
      description: "Fillings, Crowns, Bridges, Implants, Root Canal",
      bgColor: "bg-[#DFE3E7]",
    },
    {
      number: "3",
      title: "Cosmetic Dentistry",
      description: "Smile Designing, Whitening, Laminates, Tooth Jewellery",
      bgColor: "bg-[#F2F2F2]",
    },
    {
      number: "4",
      title: "Prosthetics",
      description: "Dentures, Full Mouth Rehabilitation",
      bgColor: "bg-[#DFE3E7]",
    },
    {
      number: "5",
      title: "Orthodontics & Alignment",
      description: "Braces, Diastema Closure",
      bgColor: "bg-[#F2F2F2]",
    },
    {
      number: "6",
      title: "Extractions & Oral Surgery",
      description: "Wisdom teeth, painless extractions",
      bgColor: "bg-[#DFE3E7]",
    },
  ]
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Is the treatment painful??",
      answer: `Most procedures are performed with advanced techniques and anesthesia, ensuring a painless and comfortable experience..`,
    },
    {
      question: "Do you offer same-day appointments?",
      answer: ``,
    },
    {
      question: "How long does teeth whitening take ?",
      answer: ``,
    },
    {
      question: "Are the treatment costs transparent??",
      answer: ``,
    },
    {
      question: "Do you maintain strict hygiene standards ?",
      answer: ``,
    }
  ];

  // Form state
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    address: '',
    dateOfBirth: '',
    physiciansCare: '', // Default value
    physiciansCondition: '',
    medications: '', // Default value
    medicationsList: '',
    allergies: '', // Default value
    conditions: [],
    lastDentalVisit: '',
    reasonForVisit: '',
    symptoms: [],
    dentalHistory: [],
    brushingFrequency: [],
    tobaccoUse: '', // Default value
    mouthwashUse: '', // Default value - this was missing
    dentistVisitFrequency: [],
    mainConcerns: '',
    oralHealthImprovement: ''
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      const currentValues = formData[name] || [];
      if (checked) {
        setFormData(prev => ({
          ...prev,
          [name]: [...currentValues, value]
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [name]: currentValues.filter(item => item !== value)
        }));
      }
    } else if (type === 'radio') {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };


  // Handle form submission
  const transformFormDataForBackend = (frontendData) => {
    return {
      full_name: frontendData.fullName,
      phone_number: frontendData.phoneNumber,
      email_address: frontendData.address, // Assuming 'address' is email in your form
      date_of_birth: frontendData.dateOfBirth,
      physicians_care: frontendData.physiciansCare,
      physicians_condition: frontendData.physiciansCondition,
      medications: frontendData.medications,
      medications_list: frontendData.medicationsList,
      allergies: frontendData.allergies,
      conditions: frontendData.conditions,
      last_dental_visit: frontendData.lastDentalVisit,
      reason_for_visit: frontendData.reasonForVisit,
      symptoms: frontendData.symptoms,
      dental_history: frontendData.dentalHistory,
      brushing_frequency: frontendData.brushingFrequency,
      tobacco_use: frontendData.tobaccoUse,
      mouthwash_use: frontendData.mouthwashUse,
      dentist_visit_frequency: frontendData.dentistVisitFrequency,
      main_concerns: frontendData.mainConcerns,
      oral_health_improvement: frontendData.oralHealthImprovement,
    };
  };

  // Handle form submission with RTK Query
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Transform the form data to match backend expectations
      const backendData = transformFormDataForBackend(formData);

      console.log('Sending data to backend:', backendData);

      // Call the mutation
      const result = await createDentalContact(backendData).unwrap();

      // Handle success
      console.log('Appointment created successfully:', result);
      ;

      // Reset form after successful submission
      setFormData({
        fullName: '',
        phoneNumber: '',
        address: '',
        dateOfBirth: '',
        physiciansCare: '',
        physiciansCondition: '',
        medications: '',
        medicationsList: '',
        allergies: '',
        conditions: [],
        lastDentalVisit: '',
        reasonForVisit: '',
        symptoms: [],
        dentalHistory: [],
        brushingFrequency: [],
        tobaccoUse: '',
        mouthwashUse: '',
        dentistVisitFrequency: [],
        mainConcerns: '',
        oralHealthImprovement: ''
      });

    } catch (error) {
      // Handle error
      console.error('Failed to create appointment:', error);

      // Show appropriate error message
      if (error.data && error.data.message) {
        alert(`Error: ${error.data.message}`);
      } else if (error.data && error.data.errors) {
        // Handle validation errors
        const errorMessages = Object.values(error.data.errors).flat().join(', ');
        alert(`Validation errors: ${errorMessages}`);
      } else {
        alert('Failed to book appointment. Please try again.');
      }
    }
  };


  return (
    <>
          {loading ? (
              <Loader animation={Dentalanimations} size={400} bgColor="gray-100" />
            ) : (

      <div>

      <section className="bg-[#E8DCC8]  px-6 md:mt-6  mt-0 ">
        <div className=" ">
          <div className="grid md:grid-cols-2  items-center h-full  ">
            <div className="md:space-y-8 space-y-5 mt-24 md:mt-24  ml-0 md:ml-10">
              <h1 className="text-[16px] md:text-4xl lg:text-[46px] font-[550] text-[#313131] leading-relaxed md:leading-[1.1] lg:leading-[1.2] font-['Playfair Display'] ">
                HEALTHY, CONFIDENT SMILES WITH GENTLE & EXPERT DENTAL CARE
              </h1>
              <p className="text-base md:text-xl text-[#4A4A4A] max-w-xl font-[Rufina] ">
                Led by Dr. Emmanuella Johnson, delivering advanced treatments with compassion in Pune.
              </p>

              <button onClick={() => { navigate('/dental-appointment') }} className="bg-[#5A6B7D] text-sm md:text-xl  hover:bg-[#4A5B6D] text-white px-3 py-2  md:px-6 md:py-3 rounded-md flex items-center gap-2 transition-colors font-[Raleway] duration-200 group">
                Book Your Appointment
                <FiArrowUpRight className="text-xl" />
              </button>
            </div>
            <div className="flex justify-start h-full items-end 100 mt-0">
              <img
                src={dental}
                alt="Dr. Emmanuella Johnson - Professional Dentist"
                className="md:w-[500px] md:h-[500px] 2- max- object-fit"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className='px-6 py-10'>
          <div className="max-w-7xl mx-auto space-y-5">
            <div className='max-w-7xl space-y-2 md:space-y-4'>
              <h5 className='text-[#616161] text-sm md:uppercase'>
                Where
              </h5>
              <h3 className='text-[#313131] text-2xl md:text-4xl md:uppercase'>
                OUR CLINIC
              </h3>
              <p className='font-[Rufina] text-[#313131] text-[10px] md:text-[14px]'>
                Dr. Emmanuella Johnson is an extremely passionate dentist dedicated to providing exceptional care and creating healthy, confident smiles. Known for her gentle approach and commitment to excellence, she combines advanced techniques with genuine compassion to ensure every patient feels comfortable and cared for.
              </p>

              {/* Interactive Contact Cards */}
              <div className='pt-4 grid grid-cols-1 md:grid-cols-2 gap-4'>
                {/* How to Connect Card */}
                <div
                  className={`bg-[#F2F2F2] rounded-tl-[30px] rounded-br-[30px] p-6 shadow-sm transition-all duration-300 cursor-pointer hover:shadow-md ${connectOpen ? 'ring-2 ring-[#D4E5E1]' : ''
                    }`}
                  onClick={() => setConnectOpen(!connectOpen)}
                >
                  <div className='flex items-center justify-between'>
                    <div className='flex items-center'>
                      <svg className='w-5 h-5 mr-3 text-[#616161]' fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                      </svg>
                      <span className='font-medium text-[#313131]'>How Can We Connect?</span>
                    </div>
                    <svg
                      className={`w-5 h-5 text-[#616161] transform transition-transform duration-300 ${connectOpen ? 'rotate-180' : ''
                        }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                  <div className={`overflow-hidden transition-all duration-300 ${connectOpen ? 'max-h-32 mt-4' : 'max-h-0'
                    }`}>
                    <div className='space-y-2 text-[#616161] text-sm'>
                      <div className='flex items-center'>
                        <svg className='w-4 h-4 mr-2' fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                        </svg>
                        <a href="tel:9552562534" className='hover:text-[#313131] transition-colors'>+91 95525 62534</a>
                      </div>
                      <div className='flex items-center'>
                        <svg className='w-4 h-4 mr-2' fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                        <a href="mailto:dremmanuellaj@gmail.com" className='hover:text-[#313131] transition-colors'>dremmanuellaj@gmail.com</a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Timings Card */}
                <div
                  className={`bg-[#DFE3E7] rounded-tl-[30px] rounded-br-[30px] p-6 shadow-sm transition-all duration-300 cursor-pointer hover:shadow-md ${timingsOpen ? 'ring-2 ring-[#D4E5E1]' : ''
                    }`}
                  onClick={() => setTimingsOpen(!timingsOpen)}
                >
                  <div className='flex items-center justify-between'>
                    <div className='flex items-center'>
                      <svg className='w-5 h-5 mr-3 text-[#616161]' fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span className='font-medium text-[#313131]'>Clinic Timings</span>
                    </div>
                    <svg
                      className={`w-5 h-5 text-[#616161] transform transition-transform duration-300 ${timingsOpen ? 'rotate-180' : ''
                        }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                  <div className={`overflow-hidden transition-all duration-300 ${timingsOpen ? 'max-h-32 mt-4' : 'max-h-0'
                    }`}>
                    <div className='space-y-2 text-[#616161] text-sm'>
                      <div>10:00 AM to 6:00 PM</div>
                      <div className='text-xs italic'>Sunday by appointment only</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-[#F2F2F2] rounded-tl-[30px] rounded-br-[30px] p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-700 text-sm font-medium leading-relaxed">
                  State-of-the-art, multispeciality dental clinic
                </p>
              </div>

              <div className="bg-[#DFE3E7] rounded-tl-[30px] rounded-br-[30px] p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-700 text-sm font-medium leading-relaxed">
                  Advanced technology & strict sterilization
                </p>
              </div>

              <div className="bg-[#F2F2F2] rounded-tl-[30px] rounded-br-[30px] p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-700 text-sm font-medium leading-relaxed">Personalized care</p>
              </div>

              <div className="bg-[#DFE3E7] rounded-tl-[30px] rounded-br-[30px] p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <p className="text-gray-700 text-sm font-medium leading-relaxed">Affordable treatment plans</p>
              </div>
            </div>

            <div className="overflow-hidden rounded-tr-[50px] rounded-bl-[50px] bg-[#D4E5E1]">
              <img
                src={girl}
                alt="Happy patient smiling"
                className="h-56 w-full object-cover object-center md:h-64"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="py-8  max-w-7xl mx-auto px-4">
        <div className=' space-y-2 md:space-y-4 mb-3'>
          <h5 className='text-[#616161] text-sm md:uppercase '>
            Our offers
          </h5>
          <h3 className='text-[#313131] text-2xl md:text-4xl  md:uppercase '>
            Core Services
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-3">
          {services.map((service) => (
            <div
              key={service.number}
              className={`${service.bgColor} rounded-tr-[30px] rounded-bl-[30px] p-6  transition-transform hover:scale-105`}
            >
              <h3 className="text-lg font-medium text-gray-900 mb-2">{service.number}.{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-6 py-10">
        <header className="mb-6 md:mb-8 lg:mb-10 flex items-center justify-between gap-4">
          <div className="max-w-2xl space-y-2 md:space-y-4">
            <h5 className="text-[#616161] text-sm md:uppercase">Who are we</h5>
            <h3 className="text-[#313131] text-2xl md:text-4xl md:uppercase">
              Why Choose Us
            </h3>
          </div>
          <a
            href="/dental-appointment"
            className="inline-flex items-center justify-center rounded-md  border border-border bg-card md:px-3 md:py-2 px-2 py-1 text-xs md:gap-3 gap-1 font-normal font-[Raleway] bg-[#5B656F] text-white transition"
          >
            Book Appointment   <FiArrowUpRight className="md:text-sm text-xs" />
          </a>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-4 md:gap-2">

          {/* Row 1 */}
          <div className="bg-card border border-border shadow-sm rounded-tl-[60px] overflow-hidden h-64 md:h-72 lg:h-80 md:col-span-6 lg:col-span-7">
            <img
              src={img1}
              alt="Dentist with patient in a modern clinic"
              className="h-full w-full object-cover object-top"
              loading="lazy"
            />
          </div>

          <div className="bg-card bg-[#F2F2F2] border border-border rounded-br-[60px] shadow-sm p-6 md:p-8 md:col-span-6 lg:col-span-5">
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center gap-2 text-xs tracking-wide uppercase text-muted-foreground">
                Doctors <span aria-hidden>↗</span>
              </span>
            </div>
            <h3 className="mt-4 text-pretty text-xl md:text-2xl font-medium text-[#313131] font-[Raleway]">
              Experienced dentist with international exposure
            </h3>
            <p className="mt-3 text-sm md:text-sm text-[#313131] font-[Rufina]">
              Dr. Emmanuella Johnson brings over 15 years of rich experience in dentistry. With advanced training in Smile
              Designing and Full Mouth Rehabilitation, she ensures patients receive world-class care with a personal touch.
            </p>
          </div>

          {/* Row 2 - Image → Card → Card → Image */}
          <div className="bg-card border border-border rounded-bl-[30px] shadow-sm overflow-hidden h-64 md:h-56 lg:h-56 md:col-span-3 lg:col-span-3">
            <img
              src={img2}
              alt="Dentists discussing dental X-rays"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="bg-card bg-[#F2F2F2] border border-border rounded-tr-[30px] shadow-sm p-6 md:p-8 md:col-span-3 lg:col-span-3">
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center gap-2 text-xs tracking-wide uppercase text-muted-foreground">
                Dentist <span aria-hidden>↗</span>
              </span>
            </div>
            <h3 className="mt-4 text-pretty text-xl md:text-2xl font-medium  font-[Raleway]">
              One-stop clinic: all procedures under one roof
            </h3>
          </div>
          <div className="bg-card border border-border  rounded-bl-[30px] shadow-sm overflow-hidden h-64 md:h-56 lg:h-56 md:col-span-3 lg:col-span-3 ">
            <img
              src={img3}
              alt="Oral care tools on a pastel background"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="bg-card bg-[#F2F2F2] border border-border rounded-tr-[30px] shadow-sm p-6 md:p-8 md:col-span-3 lg:col-span-3">
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center gap-2 text-xs tracking-wide uppercase text-muted-foreground">
                Dentist <span aria-hidden>↗</span>
              </span>
            </div>
            <h3 className="mt-4 text-pretty text-xl md:text-2xl font-medium font-[Raleway]">
              Advanced oral care with modern tools
            </h3>
          </div>

          {/* Row 3 */}

          <div className="bg-card border bg-[#DFE3E7] border-border rounded-tl-[30px] rounded-br-[30px] shadow-sm p-6 md:p-8 md:col-span-3 lg:col-span-4">
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center gap-2 text-xs tracking-wide uppercase text-muted-foreground">
                Meet us <span aria-hidden>↗</span>
              </span>
            </div>
            <h3 className="mt-4 text-pretty text-xl md:text-xl font-medium font-[Raleway]">
              We are a team of experts
            </h3>
            <p className="mt-3 text-sm md:text-sm leading-relaxed font-[Rufina]">
              Our clinic stands at the forefront of dental innovation and patient care, equipped with the latest technology to
              provide optimal results.
            </p>
          </div>

          <div className="bg-card border border-border shadow-sm  rounded-tl-[30px] rounded-br-[30px]  overflow-hidden h-72 md:h-72 lg:h-72 md:col-span-3 lg:col-span-5">
            <img
              src={img4}
              alt="Close-up of a smiling patient"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="bg-card border border-border bg-[#DFE3E7]  rounded-tl-[30px] rounded-br-[30px]  shadow-sm p-6 md:p-8 md:col-span-6 lg:col-span-3">
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center gap-2 text-xs tracking-wide uppercase text-muted-foreground">
                Meet us <span aria-hidden>↗</span>
              </span>
            </div>
            <h3 className="mt-4 text-pretty text-xl md:text-xl font-medium font-[Raleway]">
              Comprehensive care under one roof
            </h3>
            <p className="mt-3 text-sm md:text-sm leading-relaxed font-[Rufina] ">
              From preventive checkups to cosmetic and restorative treatments, every solution is available here with the
              highest standards of care and technology.
            </p>
          </div>

        </div>
      </section>
      <section>
        <div className='px-6 py-10'>
          <div className="max-w-7xl mx-auto space-y-5">
            <div className='max-w-7xl space-y-2 md:space-y-4'>
              <h5 className='text-[#616161] text-sm md:uppercase'>
                Why
              </h5>
              <h3 className='text-[#313131] text-2xl md:text-4xl md:uppercase'>
                Your Safety, Our Priority
              </h3>
              <p className='font-[Rufina] text-[#313131] text-[10px] md:text-[12px]'>
                We maintain strict hygiene and sterilization standards, ensuring every treatment is safe, comfortable, and stress-free.              </p>

            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-4'>

              <div className="overflow-hidden rounded-tl-[50px] rounded-br-[50px] bg-[#D4E5E1]">
                <img
                  src={dent1}
                  alt="Happy patient smiling"
                  className="h-56 w-full object-cover object-center md:h-64"
                />
              </div>

              <div className="overflow-hidden rounded-tl-[50px] rounded-br-[50px] bg-[#D4E5E1]">
                <img
                  src={dent2}
                  alt="Happy patient smiling"
                  className="h-56 w-full object-cover object-center md:h-64"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      <section className="py-16 px-6  ">
        <div className="max-w-7xl mx-auto">
          <div className='max-w-7xl space-y-2 md:space-y-4 mb-5'>
            <h5 className='text-[#616161] text-sm md:uppercase'>
              F&Q
            </h5>
            <h3 className='text-[#313131] text-2xl md:text-4xl md:uppercase'>
              Got any questions?
            </h3>
          </div>

          <div className="bg-[#F5E9D6] px-10 py-10 rounded-lg">
            <div className="space-y-6">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="border-b border-stone-300 group cursor-pointer transition-colors duration-200"
                >
                  <div
                    onClick={() => toggleFAQ(index)}
                    className="flex items-center justify-between py-2 px-4 hover:bg-orange-50 rounded-lg"
                  >
                    <p className="text-stone-700 text-base font-medium leading-relaxed font-[Raleway]">
                      {item.question}
                    </p>
                    <svg
                      className={`w-5 h-5 text-stone-600 transition-transform duration-200 ${openIndex === index ? "rotate-90" : ""
                        }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                  {openIndex === index && (
                    <div className="px-4 pb-4 text-stone-600 text-sm leading-relaxed">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="min-h-screen bg-[#F5E9D6] flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-7xl w-full p-8   sm:p-12">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 ">
              <div>
                <h1 className="text-3xl font-bold font-[Raleway] text-gray-900 mb-2">Book Your Appointment</h1>
                <p className="text-gray-600 mb-8 font-[Rufina] ">
                  Complete the form to secure your booking.
                </p>

                <form className="space-y-6  font-[Raleway]" onSubmit={handleSubmit}>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div className="relative">
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Full Name
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Phone Number
                      </label>
                    </div>
                  </div>

                  <div className='grid sm:grid-cols-2 gap-4'>
                    <div className="relative">
                      <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Email Address
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        type="date"
                        name="dateOfBirth"
                        value={formData.dateOfBirth}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Date of Birth
                      </label>
                    </div>
                  </div>

                  <fieldset className="grid gap-2">
                    <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Are you currently under physician's care ?</legend>
                    <div className="flex flex-wrap gap-4 ">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="physiciansCare"
                          value="yes"
                          checked={formData.physiciansCare === 'yes'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="physiciansCare"
                          value="no"
                          checked={formData.physiciansCare === 'no'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                      </label>
                    </div>
                  </fieldset>
                  <div className="relative">
                    <textarea
                      name="physiciansCondition"
                      value={formData.physiciansCondition}
                      onChange={handleChange}
                      rows="3"
                      className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                      style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                      required
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      Yes, for what condition?
                    </label>
                  </div>
                  <fieldset className="grid gap-2">
                    <legend className=" text-gray-600 text-[10px] md:text-[12px] mb-1">Are you taking any medications? </legend>
                    <div className="flex flex-wrap gap-4 ">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="medications"
                          value="yes"
                          checked={formData.medications === 'yes'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="medications"
                          value="no"
                          checked={formData.medications === 'no'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                      </label>
                    </div>
                  </fieldset>
                  <div className="relative">
                    <textarea
                      name="medicationsList"
                      value={formData.medicationsList}
                      onChange={handleChange}
                      rows="3"
                      className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                      style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                      required
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      List
                    </label>
                  </div>
                  <fieldset className="grid gap-2">
                    <legend className=" text-gray-600 text-[10px] md:text-[12px] mb-1 ">Do you have any allergies (medications, latex, etc.)? </legend>
                    <div className="flex flex-wrap gap-4 ">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="allergies"
                          value="yes"
                          checked={formData.allergies === 'yes'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="allergies"
                          value="no"
                          checked={formData.allergies === 'no'}
                          onChange={handleChange}
                          className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                        />
                        <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                      </label>
                    </div>
                  </fieldset>
                  <fieldset className="grid gap-2">
                    <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Do you have (or have you had) any of the following?</legend>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                      {[
                        { value: "asthma", label: "Asthma" },
                        { value: "diabetes", label: "Diabetes" },
                        { value: "high_blood_pressure", label: "High blood pressure" },
                        { value: "heart_disease", label: "Heart disease" },
                        { value: "kidney_disease", label: "Kidney disease" },
                        { value: "liver_disease", label: "Liver disease" },
                        { value: "bleeding_disorders", label: "Bleeding disorders" },
                        { value: "thyroid_issues", label: "Thyroid issues" },
                        { value: "anxiety_depression", label: "Anxiety/Depression" },
                      ].map((condition) => (
                        <label key={condition.value} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="conditions"
                            value={condition.value}
                            checked={formData.conditions.includes(condition.value)}
                            onChange={handleChange}
                            className="h-4 w-4 accent-primary"
                            disabled={isLoading}
                          />
                          <span className="text-gray-600 text-[10px] md:text-[12px]">{condition.label}</span>
                        </label>
                      ))}
                    </div>
                  </fieldset>
                  <div className="grid sm:grid-cols-2 gap-4">
                    <div className="relative">
                      <input
                        type="date"
                        name="lastDentalVisit"
                        value={formData.lastDentalVisit}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Date of last dental visit
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        type="text"
                        name="reasonForVisit"
                        value={formData.reasonForVisit}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                        required
                      />
                      <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                        Reason for visit
                      </label>
                    </div>
                  </div>
                  <fieldset className="grid gap-2">
                    <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Do you experience any of the following?</legend>
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-2 py-2">
                      {[
                        { value: "tooth_sensitivity", label: "Tooth sensitivity (hot/cold/sweets)" },
                        { value: "jaw_pain", label: "Jaw pain or clicking" },
                        { value: "bleeding_gums", label: "Bleeding gums" },
                        { value: "bad_breath", label: "Bad breath/dry mouth" },
                        { value: "teeth_grinding", label: "Grinding or clenching teeth" },
                      ].map((symptom) => (
                        <label key={symptom.value} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="symptoms"
                            value={symptom.value}
                            checked={formData.symptoms.includes(symptom.value)}
                            onChange={handleChange}
                            className="h-4 w-4 accent-primary"
                            disabled={isLoading}
                          />
                          <span className="text-gray-600 text-[10px] md:text-[12px]">{symptom.label}</span>
                        </label>
                      ))}

                    </div>
                  </fieldset>
                  <fieldset className="grid gap-2">
                    <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Have you ever had :</legend>
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-2 py-2">
                      {[
                        { value: "orthodontic_treatment", label: "Orthodontic treatment (braces)" },
                        { value: "tooth_extractions", label: "Tooth extractions" },
                        { value: "root_canal", label: "Root canal treatment" },
                        { value: "gum_disease", label: "Gum disease treatment" },
                      ].map((history) => (
                        <label key={history.value} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="dentalHistory"
                            value={history.value}
                            checked={formData.dentalHistory.includes(history.value)}
                            onChange={handleChange}
                            className="h-4 w-4 accent-primary"
                            disabled={isLoading}
                          />
                          <span className="text-gray-600 text-[10px] md:text-[12px]">{history.label}</span>
                        </label>
                      ))}
                    </div>
                  </fieldset>
                  <fieldset className="grid gap-2">
                    <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">How often do you brush your teeth?</legend>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                      {[
                        { value: "once_daily", label: "Once daily" },
                        { value: "twice_daily", label: "Twice daily" },
                        { value: "after_every_meal", label: "After every meal" },
                      ].map((frequency) => (
                        <label key={frequency.value} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="brushingFrequency"
                            value={frequency.value}
                            checked={formData.brushingFrequency.includes(frequency.value)}
                            onChange={handleChange}
                            className="h-4 w-4 accent-primary"
                            disabled={isLoading}
                          />
                          <span className="text-gray-600 text-[10px] md:text-[12px]">{frequency.label}</span>
                        </label>
                      ))}
                    </div>
                  </fieldset>

                  <div className="grid grid-cols-1 md:grid-cols-2">
                    <fieldset className="grid gap-2">
                      <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Do you use tobacco or vape?</legend>
                      <div className="flex flex-wrap gap-4 ">
                        <label className="flex items-center gap-2">
                          <input
                            type="radio"
                            name="tobaccoUse"
                            value="yes"
                            checked={formData.tobaccoUse === 'yes'}
                            onChange={handleChange}
                            className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                          />
                          <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                        </label>
                        <label className="flex items-center gap-2">
                          <input
                            type="radio"
                            name="tobaccoUse"
                            value="no"
                            checked={formData.tobaccoUse === 'no'}
                            onChange={handleChange}
                            className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                          />
                          <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                        </label>
                      </div>
                    </fieldset>
                    <fieldset className="grid gap-2">
                      <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Do you use mouthwash?</legend>
                      <div className="flex flex-wrap gap-4 ">
                        <label className="flex items-center gap-2">
                          <input
                            type="radio"
                            name="mouthwashUse"
                            value="yes"
                            checked={formData.mouthwashUse === 'yes'}
                            onChange={handleChange}
                            className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                          />
                          <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                        </label>
                        <label className="flex items-center gap-2">
                          <input
                            type="radio"
                            name="mouthwashUse"
                            value="no"
                            checked={formData.mouthwashUse === 'no'}
                            onChange={handleChange}
                            className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                          />
                          <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                        </label>
                      </div>
                    </fieldset>

                  </div>
                  <fieldset className="grid gap-2">
                    <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">How often do you visit the dentist ?</legend>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                      {[
                        { value: "every_6_months", label: "Every 6 months" },
                        { value: "once_a_year", label: "Once a year" },
                        { value: "only_when_needed", label: "Only when needed" },
                      ].map((frequency) => (
                        <label key={frequency.value} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="dentistVisitFrequency"
                            value={frequency.value}
                            checked={formData.dentistVisitFrequency.includes(frequency.value)}
                            onChange={handleChange}
                            className="h-4 w-4 accent-primary"
                            disabled={isLoading}
                          />
                          <span className="text-gray-600 text-[10px] md:text-[12px]">{frequency.label}</span>
                        </label>
                      ))}
                    </div>
                  </fieldset>
                  <div className="relative">
                    <textarea
                      name="mainConcerns"
                      value={formData.mainConcerns}
                      onChange={handleChange}
                      rows="3"
                      className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                      style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                      required
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      What are your main concerns about your teeth or smile?
                    </label>
                  </div>

                  <div className="relative">
                    <textarea
                      name="oralHealthImprovement"
                      value={formData.oralHealthImprovement}
                      onChange={handleChange}
                      rows="3"
                      className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                      style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                      required
                    />
                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                      What would you like to improve about your oral health?
                    </label>
                  </div>
                  {showSuccess && (
                    <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                      Form submitted successfully!
                    </div>
                  )}


                  <button
                    type="submit"
                    className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                  >
                    Submit Application
                    <FiArrowUpRight className="text-xl" />
                  </button>
                </form>
              </div>
              <div className="hidden lg:flex items-center justify-center">
                <div className="relative w-full h-full min-h-[500px]">
                  <img
                    src={form}
                    alt="Travel map with sunglasses and accessories"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>

      )}
    </>
  )
}

export default Dental